import './support-overview.scss';

import Swiper from 'swiper';

class SupportOverviewTopics {
    constructor ($element) {
        this.$supportOverviewTopics = $element;
        this.topicSlider = [];
        this.$topics = null;
        this.$$topicsSliderContainer = null;
        this.topicSliderActive = false;
        this.animationsSpeed = 500;
        this.wait = false;
        this.selections = {
            country: null,
            subjectType: null,
            serviceCenterId: null
        };
    }

    initialize () {
        this.initContents();
    }

    initContents () {
        this.topicSlider = [];
        this.$topics = this.$supportOverviewTopics.querySelector('[data-services-topics="root"]');
        this.$$topicsSliderContainer = this.$supportOverviewTopics.querySelectorAll('[data-services-topics="slider"]');
        this.$$topicsOpener = this.$supportOverviewTopics.querySelectorAll('[data-services-topic-index]');
        this.$targetContainer = this.$supportOverviewTopics.querySelector('[data-services-topic-targets]');
        this.$servicesTarget = this.$supportOverviewTopics.querySelector('[data-services="target"]');
        this.topicSliderActive = false;
        this.$topicSliderControls = this.$supportOverviewTopics.querySelector('[data-services-topics="controls"]');
        this.prevButton = null;
        this.nextButton = null;

        if (this.$topics) {
            if (this.$topics) {
                this.initTopics();
            }

            this.checkSizes();
        }
    }

    initTopics () {
        const $$topics = this.$supportOverviewTopics.querySelectorAll('[data-services-topics="slide"]');

        $$topics.forEach(($topic) => {
            $topic.addEventListener('click', () => {
                if ($topic.dataset.servicesInternal) {
                    window.open($topic.dataset.servicesInternal, '_self');
                } else {
                    if ($topic.dataset.servicesExternal !== '') {
                        window.open($topic.dataset.servicesExternal, '_blank');
                    }
                }
            });
        });
    }

    initTopicSlider () {
        this.topicSliderActive = true;

        if (this.$topicSliderControls) {
            this.prevButton = this.$topicSliderControls.querySelector('[data-services-topics="prev"]');
            this.nextButton = this.$topicSliderControls.querySelector('[data-services-topics="next"]');
        }

        this.$$topicsSliderContainer.forEach((slider, index) => {
            this.topicSlider[index] = new Swiper(slider, {
                slidesPerView: 'auto',
                spaceBetween: 16,
                speed: 500,
                autoHeight: false,
                navigation: {
                    prevEl: this.prevButton,
                    nextEl: this.nextButton
                },
                pagination: {
                    el: slider.nextElementSibling.querySelector('.swiper-pagination'),
                    type: 'progressbar'
                }
            });
        });
    }

    destroyTopicSlider () {
        for (let i = 0; i < this.topicSlider.length; i++) {
            if (this.topicSlider[i] !== null) {
                this.topicSlider[i].destroy(true, true);
                this.topicSlider[i] = null;
                this.topicSliderActive = false;
            }
        }
    }

    checkSizes () {
        if (!window.mediaMatch[768].matches) {
            this.initTopicSlider();
        }

        window.mediaMatch[768].addEventListener('change', (match) => {
            if (!match.matches && !this.topicSliderActive) {
                this.initTopicSlider();
            }

            if (match.matches) {
                if (this.topicSliderActive) {
                    this.destroyTopicSlider();
                }
            }
        });
    }
}

export { SupportOverviewTopics };

window.initSupportContent = ($content) => {
    const $$dtswissIdForms = $content.querySelectorAll('[data-idform="root"]');
    if ($$dtswissIdForms.length > 0) {
        import('../../modules/product-support/idform').then(({ IdForm }) => {
            for (let i = 0; i < $$dtswissIdForms.length; i++) {
                const $dtswissIdForm = $$dtswissIdForms[i];

                const dtswissIdFormAPI = new IdForm($dtswissIdForm, {
                    loader: window.OPTIONS.loader
                });
                $dtswissIdForm.API = dtswissIdFormAPI;
            }
        });
    }
};

window.addEventListener('content.loaded', (e) => {
    window.initSupportContent(document.querySelector('body'));
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $supportOverviewTopics = $context.querySelector('[data-support-overview-topics="root"]');

        if ($supportOverviewTopics) {
            const supportOverviewTopics = new SupportOverviewTopics($supportOverviewTopics);
            supportOverviewTopics.initialize();
        }
    }
});
